import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { onMounted, ref } from 'vue'
import { RouterView } from 'vue-router'
import store from '@/mobile/src/store'
import { SplashScreen } from '@capacitor/splash-screen'
import { initializeApp } from '@/mobile/src/utils/capacitor'
import '@teamhive/capacitor-single-signon'
import LoadingWithGradientBg from '@/mobile/src/components/LoadingWithGradientBg.vue'
import PushPopTransitionContainer from '@/mobile/src/components/containers/PushPopTransitionContainer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const storeRestored = ref(false) // whether data is restored when app starts, should not show anything before data restored

onMounted(() => {
    configure()
})

const configure = async () => {
    await initializeApp()
    if (store.getters['deviceInfo']?.platform !== 'web') {
        store.commit('setRunsInBackground', false)
    }
    // wait store to be restored
    await (store as any).restored
    storeRestored.value = true
    // hide splash screen
    await SplashScreen.hide()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterView), null, {
    default: _withCtx(({ Component }) => [
      (storeRestored.value)
        ? (_openBlock(), _createBlock(PushPopTransitionContainer, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], undefined, true),
            _: 2
          }, 1024))
        : (_openBlock(), _createBlock(LoadingWithGradientBg, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})